<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="2 0 21 12"
    class="w-6 fill-current text-white md:w-7"
    width="24"
    height="24"
    role="img"
  >
    <path d="M2 12H23V10H2V12ZM2 7H23V5H2V7ZM2 0V2H23V0H2Z"></path>
    <title>menu</title>
  </svg>
</template>
